import axios from '@/utils/request'
var Qs = require('qs')

export default {
    // 2020-09-15
    search(params) {
        return axios.get('/customers', params)
    },
    // 2020-09-15
    findByPhoneOrSerialNo(params) {
        return axios.get('/customers/find-by-phone-or-serial-no', params)
    },
    // 2020-09-15
    sources(params) {
        return axios.get('/customers/sources', params)
    },
    // 2020-09-15
    create(params) {
        return axios.post('/customers', params)
    },
    // 2020-09-15
    update(id, params) {
        return axios.put('/customers/' + id, params)
    },
    // 2020-09-15
    updateFlags(params) {
        return axios.put('/customers/update-flags', params)
    },
    // 2020-09-15
    delete(id) {
        return axios.delete('/customers/' + id)
    },
    // // 2020-09-17
    // follows(id) {
    //     return axios.get('/customers/' + id + '/follows')
    // },
    // // 2020-09-17
    // createFollow(id, params) {
    //     return axios.post('/customers/' + id + '/follows', params)
    // },
    // 2020-09-17
    distributeOwner(id, params) {
        return axios.put('/customers/' + id + '/distribute-owner', params)
    },
    // 2020-09-17
    recharge(id, params) {
        return axios.put('/customers/' + id + '/recharge', params)
    },

    // 2021-06-25
    rechargeScore(id, params) {
        return axios.put('/customers/' + id + '/recharge-score', params)
    },
    // 2020-09-19
    exportExcel(params) {
        return axios.get('/customers/export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
    },
    // 2020-09-19
    updateFlags(params) {
        return axios.put('/customers/update-flags', params)
    },
    // 2021-03-16
    updateGroup(params) {
        return axios.put('/customers/update-group', params);
    },
    // 2020-08-19
    vagueFindByName(params) {
        return axios.get('/customers/vague-find-by-name', params)
    },
    // 2020-08-22
    vagueFind(params) {
        return axios.get('/customers/vague-find', params)
    },
    // 2020-12-08
    findWholesale() {
        return axios.get('/customers/find-wholesale');
    },
    // 2021-07-19
    upgradeToMember(id, params) {
        return axios.put('/customers/' + id + '/upgrade-to-member', params);
    },
    // 2021-10-14
    findAllJy() {
        return axios.get('/customers/find-all-jy');
    },
    // 2020-08-31
    findById(id) {
        return axios.get('/customers/' + id)
    }

}

